import { inject, Injectable } from '@angular/core';
import { CourierDataDto } from '../types';
import { StaticStorage } from '../static-storage';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { httpRetry } from '$core/helpers/http-retry';

@Injectable({
  providedIn: 'root',
})
export class CourierInfoService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getCourierStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/courier-data').pipe(
      httpRetry(5),
      tap((res: CourierDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
